module.exports = __webpack_public_path__ + "img/Paso4Check.657206b9.svg";